import { Injectable, HostListener, OnDestroy } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Subject, Observable } from 'rxjs';
import 'rxjs/Rx';

import { AppConfigService } from '../app.config';

@Injectable()
export class SearchSterlingService {

    _error$: Subject<any> = <Subject<any>>new Subject();
    _collection$: Subject<any[]> = <Subject<any[]>>new Subject();
    _html$: Subject<any> = new Subject();

    get collection$() { return this._collection$.asObservable(); }

    get error$() { return this._error$.asObservable(); }

    constructor(private config: AppConfigService, private http: Http) {}
    search(fname: string, lname: string) {
        let url = `${this.config.url}/sterling/search`;
        if (fname) {
            url = `${url}/${fname}`;
        }

        url = `${url}/${lname}`;

        this.http.get(url,
            { headers: this.getHeaders() }).map( (response: any) => response.json()).subscribe(
            (data: any[]) => {
                this._collection$.next(data);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });
    }

    getFile(encodedFileName: string): Observable<any> {
        this.http.get(`${this.config.url}/sterling/file/${encodedFileName}`,
            { headers: this.getHeaders(true) }).map( (response: any) => response).subscribe(
            (data: any) => {
                this._html$.next(data._body);
            },
            (error: any) => {
                console.log(`Could not post search.`, error);
                this._error$.next(error);
            });

        return this._html$.asObservable();
    }

    getHeaders(authHeaderOnly = false): Headers {
        const contentHeaders = new Headers();
        contentHeaders.append('Accept', 'application/json');
        contentHeaders.append('Content-Type', 'application/json');
        contentHeaders.append('Authorization', this.config.token);
        return  contentHeaders;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/search-sterling.ts